import { ThemeEvents } from '@theme/events';

/**
 * Swaps inner markup from the variant-picker refetched product HTML so metafields
 * and prices stay in sync with the selected variant.
 * @param {HTMLElement} host
 * @param {Document} html
 */
function swapIrisPdpBlockFromHtml(host, html) {
  const blockId = host.dataset.blockId;
  if (!blockId || !html) return;
  const tag = host.tagName.toLowerCase();
  const nextHost = html.querySelector(`${tag}[data-block-id="${CSS.escape(blockId)}"]`);
  if (!nextHost) return;
  const cur = host.querySelector('[data-ref="iris-pdp-swap"]');
  const next = nextHost.querySelector('[data-ref="iris-pdp-swap"]');
  if (!cur || !next) return;
  cur.replaceWith(document.importNode(next, true));
}

class IrisPdpVariantSwap extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  /** @param {Event} e */
  #onVariantUpdate = (e) => {
    const ev = /** @type {CustomEvent} */ (e);
    const html = ev.detail?.data?.html;
    const productId = ev.detail?.data?.productId;
    if (!html) return;
    if (productId && this.dataset.productId && productId !== this.dataset.productId) return;
    swapIrisPdpBlockFromHtml(this, html);
  };

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#section = null;
  }
}

if (!customElements.get('iris-tech-sheet')) {
  customElements.define('iris-tech-sheet', class extends IrisPdpVariantSwap { });
}

if (!customElements.get('iris-price-compare')) {
  customElements.define('iris-price-compare', class extends IrisPdpVariantSwap { });
}
